import { strictParkingProductsTypes } from "../../action-types/parkingProducts.types";
import { ParkingProductsAction } from "../../actions/parkingProducts.actions";
import { success, failure, request } from "../../helpers/action.helper";
import { ParkingProductState } from ".";

export default function reduceBulkVehicleAssignments(
  state: ParkingProductState,
  action: ParkingProductsAction,
  next: () => ParkingProductState
): ParkingProductState {
  switch (action.type) {
    case success(strictParkingProductsTypes.GET_BULK_VEHICLE_IMPORT_PROGRESS):
      const { progress, errorCount } = action.payload;
      return {
        ...state,
        bulkVehicleImportProgress: {
          progress,
          errorCount,
        },
      };
    case strictParkingProductsTypes.RESET_BULK_VEHICLE_IMPORT_PROGRESS:
      return {
        ...state,
        bulkVehicleImportProgress: {
          progress: 0,
          errorCount: 0,
        },
      };

    case request(strictParkingProductsTypes.VALIDATE_VEHICLE_BULK_UPLOAD):
      return {
        ...state,
        validatedVehicleBulkUpload: {
          ...state.validatedVehicleBulkUpload,
          loading: true,
        },
      };
    case success(strictParkingProductsTypes.VALIDATE_VEHICLE_BULK_UPLOAD):
      return {
        ...state,
        validatedVehicleBulkUpload: {
          loading: false,
          amountOfVehiclesToCreate: action.payload.amountOfVehiclesToCreate,
          amountOfExceedingVehicles: action.payload.amountOfExceedingVehicles,
          fileReference: action.payload.fileReference,
        },
      };
    case failure(strictParkingProductsTypes.VALIDATE_VEHICLE_BULK_UPLOAD):
      return {
        ...state,
        validatedVehicleBulkUpload: {
          ...state.validatedVehicleBulkUpload,
          loading: false,
        },
        error: action.error!,
      };
    case success(strictParkingProductsTypes.GET_BULK_VEHICLE_ASSIGNMENTS_STATUS):
      return {
        ...state,
        isBulkVehicleAssignmentsCompleted: action.payload.isCompleted,
        loading: false,
      };
    case failure(strictParkingProductsTypes.GET_BULK_VEHICLE_ASSIGNMENTS_STATUS):
      return {
        ...state,
        isBulkVehicleAssignmentsCompleted: false,
        loading: false,
      };
    case request(strictParkingProductsTypes.START_BULK_VEHICLE_ASSIGNMENT):
      return {
        ...state,
        bulkVehicleAssignment: {
          ...state.bulkVehicleAssignment,
          loading: true,
        },
      };
    case success(strictParkingProductsTypes.START_BULK_VEHICLE_ASSIGNMENT):
      return {
        ...state,
        bulkVehicleAssignment: {
          ...state.bulkVehicleAssignment,
          loading: false,
        },
      };
    case failure(strictParkingProductsTypes.START_BULK_VEHICLE_ASSIGNMENT):
      return {
        ...state,
        bulkVehicleAssignment: {
          ...state.bulkVehicleAssignment,
          loading: false,
        },
      };
    case request(strictParkingProductsTypes.CALCULATE_WHITELIST_DELTA):
      return {
        ...state,
        calculatedWhitelistDelta: {
          ...state.calculatedWhitelistDelta,
          loading: true,
        },
      };
    case success(strictParkingProductsTypes.CALCULATE_WHITELIST_DELTA): {
      return {
        ...state,
        calculatedWhitelistDelta: {
          loading: false,
          amountOfVehiclesToCreate: action.payload.amountOfVehiclesToCreate,
          amountOfVehiclesToDelete: action.payload.amountOfVehiclesToDelete,
          amountOfVehiclesToUpdate: action.payload.amountOfVehiclesToUpdate,
          amountOfVehiclesWithNoChanges: action.payload.amountOfVehiclesWithNoChanges,
          hasChanges: action.payload.hasChanges,
          fileReference: action.payload.fileReference,
        },
      };
    }
    case failure(strictParkingProductsTypes.CALCULATE_WHITELIST_DELTA):
      return {
        ...state,
        calculatedWhitelistDelta: {
          ...state.calculatedWhitelistDelta,
          loading: false,
        },
        error: action.error!,
      };
    default:
      return next();
  }
}
